__turbopack_context__.v({
  "floating": "MobileMenu-module-scss-module__EoHt0q__floating",
  "mobileMenu": "MobileMenu-module-scss-module__EoHt0q__mobileMenu",
  "mobileMenu__close": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__close",
  "mobileMenu__email": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__email",
  "mobileMenu__footer": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__footer",
  "mobileMenu__header": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__header",
  "mobileMenu__item": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__item",
  "mobileMenu__lg": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__lg",
  "mobileMenu__line": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__line",
  "mobileMenu__list": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__list",
  "mobileMenu__nav": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__nav",
  "mobileMenu__pl25": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__pl25",
  "mobileMenu__right": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__right",
  "mobileMenu__socials": "MobileMenu-module-scss-module__EoHt0q__mobileMenu__socials",
  "open": "MobileMenu-module-scss-module__EoHt0q__open",
  "rotate": "MobileMenu-module-scss-module__EoHt0q__rotate",
});
